import React, { FC } from 'react'

import { ErrorBoundary } from '@sentry/react'
import { useParams } from 'react-router'

import { GiftsIndexEmpty } from 'components/page/ForeignProfile/Gifts/GiftsIndexEmpty'
import { GiftsIndexView } from 'components/page/ForeignProfile/Gifts/GiftsIndexView'
import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'
import { ProfileRouteParams } from 'components/paths'
import { GQLGender } from 'generated-graphql/graphql'

export const ForeignGifts: FC<{
  gender: GQLGender
  gifts: NonNullable<GQLForeignRootQuery['user']>['gifts']['gifts']['nodes']
  giftsCommonFormat: GQLForeignRootQuery['ui']['giftFormats']
  giftsCount: number
  presentVip?: NonNullable<GQLForeignRootQuery['user']>['vip']['presentVip']
}> = ({ gender, gifts, giftsCount, giftsCommonFormat, presentVip }) => {
  const { userId } = useParams<ProfileRouteParams>()

  const hasGiftsOrPresentVip = giftsCount > 0 || Boolean(presentVip)

  if (!hasGiftsOrPresentVip) {
    return <GiftsIndexEmpty gender={gender} userId={Number(userId)} />
  }

  return (
    <ErrorBoundary>
      <GiftsIndexView
        gifts={gifts}
        giftsCommonFormat={giftsCommonFormat}
        gender={gender}
        presentVip={presentVip}
      />
    </ErrorBoundary>
  )
}
